import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/auth';
import { getCookie } from '../lib/common';

const GenioWithAuth = (Component) => {
  const AuthRoute = () => {
    const navigate = useNavigate();
    const [authState] = useAuth();
    const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
    const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));

    if (
      (authState?.profileDetails?.empCode || profile?.empCode) &&
      getCookie('EmpCode') &&
      selectedBusinessGenio &&
      selectedBusinessGenio.docId
    ) {
      return <Component />;
    }
    return navigate('/genio');
  };
  return AuthRoute;
};

GenioWithAuth.propTypes = {
  Component: PropTypes.node,
};
export default GenioWithAuth;
